var App = App || {};

App.Login = (function ($) {
    "use strict";

    var _isOpen,
        $toggle,
        $panel,
        $body,
        firstFocusable,
        lastFocusable,
        $orpheusLogin;

    function init() {
        $toggle = $('.login__toggle');
        $panel = $('.login__panel');
        $body = $('body');
        $orpheusLogin = $(".orpheus-login");

        $orpheusLogin.each(function () {
            var $this = $(this),
                $button = $this.find("button"),
                $input = $this.find('input[type="text"]'),
                $error = $this.find(".error");

            $button.on("click", function (e) {
                var orpheusDomain = onlineBankingUrl;
                var newTab = true;
                var userName = $input.val();

                if (userName) {
                    $error.hide();

                    openOrpheus(userName, orpheusDomain, newTab);
                } else {
                    $error.show();
                }

                e.preventDefault();
            });
        });

        $(".login__toggle")
            .on('keydown.login', function (e) {
                if (e.keyCode === 13) {
                    toggleLogin;
                }
            });

        $toggle
            .on('click', toggleLogin);

        $panel
            .on('keydown', function (e) {
                if (e.key === 'Tab' || e.keyCode === 9) {
                    if (document.activeElement === lastFocusable) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                        e.preventDefault();
                        closeLogin();
                    }
                }
            });

        App.Base.$body
            .on('keydown', function (e) {
                if (_isOpen && e.keyCode === 27) {
                    closeLogin();
                }
            });


        $("#login-menu").on('hidden.bs.offcanvas', function () {
            if (_isOpen) {
                closeLogin();
            }
        });
    }

    function openOrpheus(userName, host, newTab) {
        var form, input;

        form = document.createElement('form');
        form.setAttribute('action', host + '/UserLogin');
        form.setAttribute('method', 'POST');
        if (newTab) {
            form.setAttribute('target', '_blank');
        }
        form.style.display = 'none';

        input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.setAttribute('name', 'userName');
        input.setAttribute('value', userName);
        form.appendChild(input);

        input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.setAttribute('name', 'loginMode');
        input.setAttribute('value', 'Password');
        form.appendChild(input);

        document.body.appendChild(form);
        form.submit();
    }


    function toggleLogin() {
        _isOpen ? closeLogin() : openLogin();
    }

    function openLogin() {
        var alertHeight = $("#site-alerts").length !== 0 ? $("#site-alerts").outerHeight() : 0;
        var headerHeight = $("#site-header").outerHeight() + alertHeight;
        var bp = ZAGFramework.GetCurrentBP();

        if (App.HamburgerNav.isOpen()) {
            App.HamburgerNav.closeMenu();
        }
      
        $toggle
            .attr('aria-expanded', 'true')
            .addClass('login__toggle--open');

        $('.offcanvas').on('shown.bs.offcanvas', function () {
            // Find the first input field within the offcanvas
            var firstInput = $(this).find('input:visible:enabled:first');

            // Set focus on that field
            if (firstInput.length) {
                firstInput.focus();
            }
        });

        if (bp === 'xs' || bp === 'sm' || bp === 'md') {
            $("#login-menu").css("top", headerHeight + "px");
            $(".offcanvas-backdrop").css("top", headerHeight + "px");
        }
 
        _isOpen = true;
    }

    function closeLogin() {
        $toggle
            .attr('aria-expanded', 'false')
            .removeClass('login__toggle--open')
            .focus();

        $toggle.focus();

        _isOpen = false;
    }

    function updateFocusableElements() {
        firstFocusable = $panel.find('a, button, :input, [tabindex]').first(':visible')[0];
        lastFocusable = $panel.find('a, button, :input, [tabindex]').last(':visible')[0];
    }

    $('.login-promo-personalized').each(function () {
        if (!isEmpty($(this).find(".login__panel-promo > *:last-child"))) {
            $('.login-promo-default').hide();
        }
        else {
            if (!isEmpty($(this).find(".login__panel-promo > *:last-child"))) {
                $('.login-promo-personalized').hide();
            }
        }
    });



    function isEmpty(el) {
        return !$.trim(el.html())
    }

    return {
        init: init,
        closeLogin: closeLogin,
        isOpen: function () { return _isOpen; }
    };
})(jQuery);

$(function () {
    App.Login.init();
});